module.exports = __webpack_public_path__ + "static/storesearch1-0d4c0dab5b80f3387a166e7e4597f2a6.png";